<template>
    <div id="bottomLeftMid">
        <div class="bg-color-black">
            <myTitle :icon="'plug'">今日耗电</myTitle>
            <div class="d-flex jc-center body-box pl-1 pr-1">
                <bottomLeftChart></bottomLeftChart>
            </div>
        </div>
    </div>
</template>
  
<script>
import bottomLeftChart from '@/components/power/bottomLeft/mid'
import myTitle from '@/components/common/title'
export default {
    data() {
        return {
            num: '0020621'
        }
    },
    components: {
        bottomLeftChart,
        myTitle
    },
    computed: {
        list: function () {
            const reg = /(\d)(?=(?:\d{3})+$)/g;
            const arr = this.num.toString().replace(reg, '$1,')
            return arr.toString()
        }
    }
}
</script>
  
<style lang="scss" scoped>
$box-height: 390px;
$box-width: 100%;

#bottomLeftMid {
    padding: 16px;
    padding-top: 20px;
    height: $box-height;
    width: $box-width;
    border-radius: 5px;

    .bg-color-black {
        height: $box-height - 30px;
        border-radius: 10px;
    }

    .text {
        color: #c3cbde;
    }

    .body-box {
        border-radius: 10px;
        overflow: hidden;

        .card {
            background-color: rgba(4, 49, 128, .6);
            color: #08e5ff;
            width: 70px;
            font-size: 42px;
            font-weight: 700;
            line-height: 70px;
            text-align: center;
            margin: 3px;
        }
    }
}
</style>
  